import Vue from 'vue'
import Router from 'vue-router'
import {
    routerMode
} from '@/config/env'
Vue.use(Router)
export default new Router({
    mode: routerMode,
    routes: [
        {
            path: '/',
            name: 'index',
            component: () => import('@/views/index'),
            meta: {
                foot: true, navbar: 0, keepAlive: true
            }
        }, {
            path: '/apps',
            name: 'apps',
            component: () => import('@/views/apps/index'),
            meta: {
                keepAlive: true,
                navbar: 1
            }
        }, {
            path: '/news',
            name: 'news',
            component: () => import('@/views/news'),
            meta: {
                keepAlive: true,
                navbar: 3
            }
        }, {
            path: '/membersPower',
            name: 'membersPower',
            component: () => import('@/views/membersPower/index'),
            meta: {
                keepAlive: true,
                navbar: 2,
                foot: true,

            }
        }, {
            path: '/about',
            name: 'about',
            component: () => import('@/views/about'),
            meta: {
                keepAlive: true,
                foot: true,
                navbar: 5
            }
        }, {
            path: '/newsDetail',
            name: 'newsDetail',
            component: () => import('@/views/newsDetail'),
            meta: {
                navbar: 3
            }
        },
        {
            path: '/cityPartner',
            name: 'cityPartner',
            component: () => import('@/views/cityPartner'),
            meta: {
                foot: true,
                navbar: 4
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/login'),
            meta: {

            }
        }, {
            path: '/advice',
            name: 'advice',
            component: () => import('@/views/advice'),
            meta: {
                navbar: 0

            }
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/common/home'),
            children: [
                {
                    //个人中心
                    path: '/myCenter',
                    name: "myCenter",
                    component: function (resolve) {
                        require(['@/views/myCenter/index.vue'], resolve)
                    }
                },
                {
                    path: '/orderManage',
                    name: "orderManage",
                    component: function (resolve) {
                        require(['@/views/orderManage/index'], resolve)
                    }
                },
                {
                    //订单详情
                    path: '/orderDetail',
                    name: "orderDetail",
                    component: function (resolve) {
                        require(['@/views/orderManage/orderDetail.vue'], resolve)
                    }
                },
                {
                    //阿姨简历详情
                    path: '/auntDetail',
                    name: "auntDetail",
                    component: function (resolve) {
                        require(['@/views/orderManage/auntDetail.vue'], resolve)
                    }
                },
                {
                    //订单管理
                    path: '/addOrder',
                    component: function (resolve) {
                        require(['@/views/orderManage/addOrder.vue'], resolve)
                    }
                },
                {
                    //订单管理
                    path: '/orderContent',
                    component: function (resolve) {
                        require(['@/views/orderManage/orderContent.vue'], resolve)
                    }
                },
                {
                    //订单管理
                    path: '/editorOrder/:orderId/:operationState',
                    component: function (resolve) {
                        require(['@/views/orderManage/editorOrder.vue'], resolve)
                    }
                },
                {
                    //订单管理 快捷订单
                    path: '/editorFastOrder/:orderId/:isAdd',
                    component: function (resolve) {
                        require(['@/views/orderManage/editorFastOrder.vue'], resolve)
                    }
                },
            ]
        }

    ]
})
// 解决路由重复点击报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js